import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import styles from './Header.module.css';

interface HeaderProps {
  headerActions?: ReactNode;
}

export function Header({ headerActions }: HeaderProps) {
  return (
    <header className={styles.header}>
      <div className={styles.headerLeft}>
        <Link to="/" className={styles.logoLink} aria-label="SOFTEL">
          <img src="/assets/xella-logo.svg" alt="SOFTEL" className={styles.logo} />
        </Link>
      </div>
      {headerActions && <div className={styles.headerRight}>{headerActions}</div>}
    </header>
  );
}
